/** Página 404: código de error, botón al home y link para volver a la página anterior. */
import React from "react";
import { Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import "./notfound.css";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="error-page">
      <div className="error-page-card">
        <p className="error-page-code">404</p>
        <Typography.Title level={4} className="error-page-title" style={{ margin: "0 0 8px" }}>
          Página no encontrada
        </Typography.Title>
        <p className="error-page-description">
          La página que buscás no existe o fue movida a otra ubicación.
        </p>
        <Button
          type="primary"
          className="error-page-btn"
          onClick={() => navigate("/home")}
        >
          Volver al inicio
        </Button>
        <span className="error-page-link" onClick={() => navigate(-1)}>
          ← Volver a la página anterior
        </span>
      </div>
    </div>
  );
};

export default NotFound;
